/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

export class CommercialAccountInstantMsg {
  id: number;
  instantMsgType: CommercialAccountInstantMsgType;
  instantMsg: string;

  constructor() {
    this.id = 0;
    this.instantMsgType = CommercialAccountInstantMsgType.other;
    this.instantMsg = "";
  }
}

export enum CommercialAccountInstantMsgType {
  skype = "Skype",
  facebookMessenger = "FB Messenger",
  whatsapp = "Whatsapp",
  other = "Other",
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
